/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_3_DInputs */

const en_cp_why_3_d = /** @type {(inputs: Cp_Why_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturers and problem owners have a real role: approving phases. Client commitment is the number-one success factor in capstone projects.`)
};

const id_cp_why_3_d = /** @type {(inputs: Cp_Why_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosen dan pemilik masalah punya peran nyata: menyetujui fase. Komitmen klien adalah faktor sukses capstone nomor satu.`)
};

/**
* | output |
* | --- |
* | "Lecturers and problem owners have a real role: approving phases. Client commitment is the number-one success factor in capstone projects." |
*
* @param {Cp_Why_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_3_d = /** @type {((inputs?: Cp_Why_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_3_d(inputs)
	return en_cp_why_3_d(inputs)
});